const businessInit = {
  name: "",
  address: "",
  keywords: "",
  phoneNumbers: "",
  whatsApp: "",
  delivery: false,
  location: "",
  category: -1,
  ownerDni: "",
  schedule: [
    { day: 0, range: 0, startTime: "", endTime: "" },
    { day: 0, range: 1, startTime: "", endTime: "" },
    { day: 1, range: 0, startTime: "", endTime: "" },
    { day: 1, range: 1, startTime: "", endTime: "" },
    { day: 2, range: 0, startTime: "", endTime: "" },
    { day: 2, range: 1, startTime: "", endTime: "" },
    { day: 3, range: 0, startTime: "", endTime: "" },
    { day: 3, range: 1, startTime: "", endTime: "" },
    { day: 4, range: 0, startTime: "", endTime: "" },
    { day: 4, range: 1, startTime: "", endTime: "" },
    { day: 5, range: 0, startTime: "", endTime: "" },
    { day: 5, range: 1, startTime: "", endTime: "" },
    { day: 6, range: 0, startTime: "", endTime: "" },
    { day: 6, range: 1, startTime: "", endTime: "" },
  ],
  webSite: "",
};

const business = {
  id: "",
  name: "",
  address: "",
  keywords: "",
  phoneNumbers: "",
  whatsApp: "",
  delivery: "",
  category: "",
  ownerDni: "",
  location: "",
  schedule: [
    { day: 0, range: 0, startTime: "", endTime: "" },
    { day: 0, range: 1, startTime: "", endTime: "" },
    { day: 1, range: 0, startTime: "", endTime: "" },
    { day: 1, range: 1, startTime: "", endTime: "" },
    { day: 2, range: 0, startTime: "", endTime: "" },
    { day: 2, range: 1, startTime: "", endTime: "" },
    { day: 3, range: 0, startTime: "", endTime: "" },
    { day: 3, range: 1, startTime: "", endTime: "" },
    { day: 4, range: 0, startTime: "", endTime: "" },
    { day: 4, range: 1, startTime: "", endTime: "" },
    { day: 5, range: 0, startTime: "", endTime: "" },
    { day: 5, range: 1, startTime: "", endTime: "" },
    { day: 6, range: 0, startTime: "", endTime: "" },
    { day: 6, range: 1, startTime: "", endTime: "" },
  ],
  webSite: "",
};

const setBusinessInitState = () => {
  return businessInit;
};
const formatTime = (time) => {
  if (time.hour !== undefined) {
    let hour = time.hour.toString().length === 1 ? "0" + time.hour : time.hour;
    let minutes =
      time.minutes.toString().length === 1 ? "0" + time.minutes : time.minutes;
    return `${hour}:${minutes}`;
  }
  return "";
};

const getJsonSchedule = (schedule) => {
  let scheduleJson = [];
  schedule.days.forEach((day, indexDay) => {
    let indexRanges = 0;
    while (indexRanges < 2) {
      let arrayElement = {
        day: indexDay,
        range: indexRanges,
        startTime:
          day.ranges[indexRanges] !== undefined
            ? formatTime(day.ranges[indexRanges].startTime)
            : "",
        endTime:
          day.ranges[indexRanges] !== undefined
            ? formatTime(day.ranges[indexRanges].endTime)
            : "",
      };
      scheduleJson.push(arrayElement);
      indexRanges++;
    }
  });
  return scheduleJson;
};

const businessParserFromServer = (objectResponse) => {
  let out = business;
  out.id = objectResponse.id;
  out.name = objectResponse.name;
  out.address = objectResponse.address;
  out.ownerDni = objectResponse.ownerDni;
  out.keywords = objectResponse.keywords.toString();
  out.phoneNumbers = objectResponse.phoneNumbers.toString();
  out.whatsApp = objectResponse.whatsApp.toString();
  out.delivery = objectResponse.delivery;
  out.location = `${objectResponse.location.latitude}, ${objectResponse.location.longitude}`;
  out.category = objectResponse.category;
  out.webSite = objectResponse.webSite;
  out.schedule = getJsonSchedule(objectResponse.baseSchedule);
  return out;
};

const businessParserToServer = (objectFrontEnd) => {
  let scheduleFront = objectFrontEnd.schedule;
  let days = [];
  let ranges = [];
  let hour;
  let minutes;
  scheduleFront.forEach((scheduleItem, index) => {
    let rangeItem = {};
    if (index !== 0 && scheduleItem.day !== scheduleFront[index - 1].day) {
      days.push({ ranges });
      ranges = [];
    }
    if (scheduleItem.startTime !== "" && scheduleItem.endTime !== "") {
      [hour, minutes] = scheduleItem.startTime.split(":");
      let startTime = { hour, minutes };
      [hour, minutes] = scheduleItem.endTime.split(":");
      let endTime = { hour, minutes };
      rangeItem = { startTime, endTime };
      ranges.push(rangeItem);
    }
  });
  days.push({ ranges });
  let [latitude, longitude] = objectFrontEnd.location.split(",");
  let newLocation = { latitude, longitude };
  let out = {
    ...objectFrontEnd,
    location: newLocation,
    whatsApp:
      objectFrontEnd.whatsApp.length === 0
        ? []
        : objectFrontEnd.whatsApp.split(","),
    phoneNumbers:
      objectFrontEnd.phoneNumbers.length === 0
        ? []
        : objectFrontEnd.phoneNumbers.split(","),
    keywords:
      objectFrontEnd.keywords.length === 0
        ? []
        : objectFrontEnd.keywords.split(","),
    schedule: null,
    baseSchedule: { days },
  };
  return out;
};

export {
  businessParserFromServer,
  businessParserToServer,
  setBusinessInitState,
};
